export const Bio = {
  name: "Sushant Singh",
  roles: [
    "Currently Learning MERN ",
    "Looking For Opportunity",
    "Developer",
    "Love to Code...",
    "Love to Fix...",
  ],
  description:
    "I am Sushant, a motivated and innovative full-stack web developer. With a solid foundation in both front-end and back-end technologies, including HTML, CSS, JavaScript, Node.js, and MongoDB, I am eager to contribute fresh ideas and coding skills to the world of web development",
  github: "https://github.com/thisissushant",
  resume:
    "https://drive.google.com/file/d/1uHTS7sNh8n4xw3yrLf9AWUYmmE6KGkB4/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/sushantbibhu/",
  twitter: "https://twitter.com/sushantbibhu",
};

export const skills = [
  {
    title: "Technology",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Typescript",
        image: "https://cdn.worldvectorlogo.com/logos/typescript.svg",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Mongoose",
        image:
          "https://raw.githubusercontent.com/detain/svg-logos/af43b58bee054f40b2c215d97b983d03b190f0d4/svg/m/mongoose-1.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },

      {
        name: "Cloudinary",
        image: "https://cdn.worldvectorlogo.com/logos/cloudinary-2.svg",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Tailwind",
        image:
          "https://tailwindcss.com/_next/static/media/tailwindcss-mark.3c5441fc7a190fb1800d4a5c7f07ba4b1345a9c8.svg",
      },
      {
        name: "Wordpress",
        image: "https://cdn.worldvectorlogo.com/logos/wordpress-icon.svg",
      },
      {
        name: "JWT",
        image: "https://cdn.worldvectorlogo.com/logos/jwt-3.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 1,
    img: "data:image/jpeg;base64,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",
    role: "Full Stack Engineer",
    company: "Easework AI",
    date: "May 2024, August 2024",
    desc: "At Easework AI, I develop sophisticated user interfaces using React and Material-UI (MUI), leveraging a component-based architecture to create modular, scalable, and maintainable front-end applications. My role focuses on building dynamic, responsive layouts while ensuring seamless data integration through robust API connections.I am responsible for integrating and testing RESTful APIs, utilizing tools like Postman to rigorously validate endpoints and ensure reliable data exchange between the front-end and backend services. Although I do not create backend services, I work closely with FastAPI to populate data and enhance the interaction between our front-end systems and existing backend infrastructure.Additionally, I handle the occasional deployment of our applications on AWS EC2 instances, ensuring they are hosted in scalable and secure environments. My work also includes developing data-driven applications using Streamlit, where I create interactive dashboards and visualizations to provide actionable insights for our clients",
    skills: [
      "React",
      "Material UI",
      "API Integration",
      "AWS",
      "Python",
      "Javascript",
      "Fast API",
    ],
    doc: "https://easeworkai.com/",
  },
  {
    id: 0,
    img: "https://thetrendy.in/wp-content/uploads/2022/11/cropped-The-Trendy-2-138x51.png",
    role: "Developer",
    company: "The Trendy",
    date: "July 2021, January 2024",
    desc: "Founded and operated an e-commerce store specializing in sneaker sales. Single-handedly conceptualized, designed, and developed the entire website on WordPress, seamlessly integrating Shiprocket for logistics efficiency and Stripe payment gateway for secure transactions. Hosted the site on Hostinger. Implemented various plugins to enhance website performance and user experience. Over two years, cultivated a thriving online presence, achieving an overall revenue of 80 lac plus. Effectively managed the complete web development lifecycle, consistently adapting to market trends and user feedback to optimize the site for peak performance.",
    skills: [
      "Wordpress",
      "User Interface",
      "API Integration",
      "HTML and CSS",
      "Responsive Web Design",
    ],
    doc: "https://thetrendy.in/",
  },
];
export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0vrz4GdGcYBko5F6gmvs08xWS0ov04Z9OwtcRSudpQw&s",
    school:
      "Swami Keshvanand Institute of Technology Management & Gramothan, Jaipur",
    date: "Aug 2017 - Sep 2021",
    degree: "Bachelor of Technology - B-Tech, Information Technology",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5747-UypWfNVrui1bv6Wm5fFJTKN_uv89Q7opkRzrzSXq4b798uypP9CdadcFn4dDo3I&usqp=CAU",
    school:
      "Uttar Pradesh State Board of High School and Intermediate Education",
    date: "Apr 2015 - Apr 2017",
    degree: "(Class XI, XII) - Physics Chemistry Maths",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmvvmXomSGNAhQRXZVj7En-C8UjxT39oWRbw&usqp=CAU",
    school: "Central Board of Secondary Education (CBSE)",
    date: "Till 2015",
    degree: "(Till Class X) - Study all common Subjects",
  },
];

export const projects = [
  {
    id: 0,
    title: "Password Generator",
    date: "Oct 2023 - oct 2023",
    description:
      "The Random Password Generator app creates strong, unique passwords for enhanced online security. Offering customization options, it ensures robust password generation. With features like clipboard integration and a user-friendly interface, it simplifies the process of creating and managing secure passwords across platforms.",
    image:
      "https://github.com/thisissushant/Images/blob/main/random-password-generator.jpg?raw=true",
    tags: ["React Js", "Node Js", "Tailwind CSS"],
    category: "projects",
    github: "https://github.com/thisissushant/random-password",
    webapp: "https://sushant-password-generator.netlify.app/",
  },
  {
    id: 2,
    title: "Trackify",
    date: "Jun 2023 - Jul 2023",
    description:
      "Trackify is a web application designed to streamline task management and enhance productivity in the workplace. It provides a user-friendly interface for employers to keep track of their employees' daily work activities and empowers employees to log their tasks efficiently. \nAdmin Credentials: # Email: testadmin@gmail.com #Password- 123@testadmin, Employee Credentials:	#Email: testemployee@gmail.com	#Password- 123@Testemployee",
    image:
      "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
    tags: [
      "Docker",
      "AWS",
      "DuckDNS",
      "Eslint",
      "Husky",
      "CI/CD",
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
    ],
    category: "certificate",
    github: "https://github.com/rishavchanda/Trackify",
    webapp: "https://trackify-management.netlify.app/",
  },
  {
    id: 3,
    title: "Headlines",
    date: "Apr 2023 - May 2023",
    description:
      "Headlines is a web application built with React.js that allows users to browse and read the latest news articles from a news API. It provides a user-friendly interface for accessing news articles, complete with article titles, descriptions, images, authors, and publication dates.",
    image:
      "https://github.com/thisissushant/Images/blob/main/News%20App.png?raw=true",
    tags: ["React Js", "NewsAPI", "Node Js", "Bootstrap"],
    category: "projects",
    github: "https://github.com/thisissushant/daily-news",
  },
  {
    id: 4,
    title: "Unit Converter",
    date: "July 2023 - Aug 2023",
    description:
      "This web application allows users to easily input values in feet and inches and receive instant conversions, such as converting feet to inches or vice versa. Users can also perform operations like adding or subtracting measurements in this format. ",
    image:
      "https://github.com/thisissushant/Images/assets/82133186/5800dfd1-9466-4a2b-8ae1-fd5c0be52882",
    tags: ["HTML", "CSS", "Javascript", "Netlyfy", "Github"],

    category: "projects",
    github: "https://github.com/thisissushant/Unit-Converter",
    webapp: "https://sushant-unit-converter.netlify.app/",
  },
  {
    id: 5,
    title: "Minion Translator",
    date: "June 2023 - June 2023",
    description:
      "This project is a simple web application that translates English text to Minion language. It is built using HTML, CSS, and JavaScript. This project uses the Fun Translation API to translate text ",
    image:
      "https://github.com/thisissushant/Images/blob/main/minion-translation.jpg?raw=true",
    tags: ["React Js", " Fun Translation API", "Tailwind CSS"],
    category: "projects",
    github:
      "https://github.com/thisissushant/Translating-English-text-to-minion",
    webapp: "https://sushant-minion-translation.netlify.app/",
  },
  {
    id: 6,
    title: "Show Shuffle",
    date: "Dec 2023 - Currently Working",
    description:
      "Backend for a video hosting website with integrated tweet functionalities and more, try to optimize with production-grade practises. Interactive video engagement with features like likes, dislikes, and comments. Secure sign-up and login functionalities. Userauthentication using JWT and bcrypt. Empowers users to subscribe and unsubscribe from channels. Utilizing a combination of session and cookies, Use Multer Cloudinary for efficient handling of video uploads and storage",
    image:
      "https://github.com/thisissushant/Images/blob/main/Show.png?raw=true",
    tags: [
      "Node.js, Express.js, MongoDB, Mongoose, JWT, Multer, Bcrypt, Cloudinary",
    ],
    category: "projects",
    github: "https://github.com/thisissushant/show-shuffle",
  },
  {
    id: 7,
    title: "React Basic",
    date: "September 7, 2023 ",
    description:
      "Learning: React Basics, Component Lifecycle, State Management, Routing, Forms and User Input, Working with APIs, Styling in React, Testing React Applications, Deploymen",
    image:
      "https://github.com/thisissushant/Images/blob/main/React%20Basic.jpg?raw=true",
    tags: ["React, Application development, Front-End Web Development"],
    category: "certificates",
    github: "https://coursera.org/verify/98TJ66B26GNX",
  },
  {
    id: 8,
    title: "React Advanced",
    date: "September 25, 2023",
    description:
      "Learning: Advanced State Management, Performance Optimization, Server-Side Rendering, Advanced Hooks, GraphQL Integration, Advanced Com-ponent Patterns, Testing Strategies, Advanced React Patterns, TypeScript with React, React Performance Tools",
    image:
      "https://github.com/thisissushant/Images/blob/main/React%20Advance.png?raw=true",
    tags: [
      "Front-End Web Development",
      "React (Web Framework)",
      "Unit Testing",
    ],
    category: "certificates",
    github: "https://coursera.org/verify/GXKF2AHJ663S",
  },
  {
    id: 9,
    title: "Programming with JavaScript",
    date: "August 19, 2023",
    description:
      "Learning: JavaScript Basics, Functions and Scope, Arrays and Objects, DOM Manipulation, Events and Event Handling, Asynchronous JavaScript, Error Handling, JavaScript Libraries and Frameworks, AJAX and Fetch Local Storage and Cookies, ES6+ Features, Testing and Debugging, Security, Performance Optimization",
    image:
      "https://github.com/thisissushant/Images/blob/main/Java%20Sc.png?raw=true",
    tags: [
      "JavaScript",
      "Test-Driven Development",
      "Object-Oriented Programming (OOP)",
    ],
    category: "certificates",
    github: "https://coursera.org/verify/MUH8MPG2VYG2",
  },
  {
    id: 10,
    title: "Programming with JavaScript",
    date: "September 1, 2023",
    description:
      "Learning: Create a simple form with a responsive layout using HTML5 and CSS, Create a responsive layout using CSS, Create a UI using Bootstrap, Implement debugging tools.  ",
    image:
      "https://github.com/thisissushant/Images/blob/main/HTML,%20CSS.png?raw=true",
    tags: ["HTML and CSS", "Debugging", "JavaScript"],
    category: "certificates",
    github: "https://coursera.org/verify/CE7M3V7U4B97",
  },
];
